<template>
    <div>
        <loading :active="isLoadingModel" :can-cancel="true" color="#274461" :is-full-page="fullPage"></loading>
        <div class="grid">
            <div class="col-12 lg:col-3 xl:col-3 zoom" style="width: 20%; height: 100%">
                <div class="card mb-0" id="custom_card_shadow" @click="go('/categories')">
                    <div class="flex justify-content-between mb-0">
                        <div>
                            <span class="block text-500 font-medium mb-3">{{
                                $t("total_dept")
                            }}</span>
                            <div class="text-5xl" style="color: #3f51b5; font-size: 20px; font-weight: 800">
                                {{ total_categories }}
                            </div>
                        </div>
                        <div class="flex align-items-center justify-content-center bg-orange-100 border-round"
                            style="width: 4rem; height: 4rem">
                            <i class="pi pi-table text-orange-500 text-5xl"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 lg:col-3 xl:col-3 zoom" style="width: 20%; height: 100%">
                <div class="card mb-0" id="custom_card_shadow" @click="go('/tickets', 1)">
                    <div class="flex justify-content-between mb-0">
                        <div>
                            <span class="block text-500 font-medium mb-3">{{
                                $t("open_ticket")
                            }}</span>
                            <div class="text-5xl" style="color: #3f51b5; font-size: 20px; font-weight: 800">
                                {{ open_tickets }}
                            </div>
                        </div>
                        <div class="flex align-items-center justify-content-center bg-cyan-100 border-round"
                            style="width: 4rem; height: 4rem">
                            <i class="pi pi-envelope text-cyan-500 text-5xl"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 lg:col-3 xl:col-3 zoom" style="width: 20%; height: 100%">
                <div class="card mb-0" id="custom_card_shadow" @click="go('/tickets', 2)">
                    <div class="flex justify-content-between mb-0">
                        <div>
                            <span class="block text-500 font-medium mb-3">{{
                                $t("InProgress_Ticket")
                            }}</span>
                            <div class="text-5xl" style="color: #3f51b5; font-size: 20px; font-weight: 800">
                                {{ inprogress_tickets }}
                            </div>
                        </div>
                        <div class="flex align-items-center justify-content-center bg-cyan-100 border-round"
                            style="width: 4rem; height: 4rem">
                            <i class="pi pi-envelope text-cyan-500 text-5xl"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 lg:col-3 xl:col-3 zoom" style="width: 20%; height: 100%">
                <div class="card mb-0" id="custom_card_shadow" @click="go('/tickets', 3)">
                    <div class="flex justify-content-between mb-0">
                        <div>
                            <span class="block text-500 font-medium mb-3">{{
                                $t("close_ticket")
                            }}</span>
                            <div class="text-5xl" style="color: #3f51b5; font-size: 20px; font-weight: 800">
                                {{ closed_tickets }}
                            </div>
                        </div>
                        <div class="flex align-items-center justify-content-center bg-purple-100 border-round"
                            style="width: 4rem; height: 4rem">
                            <i class="pi pi-lock text-purple-500 text-5xl"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 lg:col-3 xl:col-3 zoom" style="width: 20%; height: 100%">
                <div class="card mb-0" id="custom_card_shadow" @click="go('/ward', 'closed')">
                    <div class="flex justify-content-between mb-0">
                        <div>
                            <span class="block text-500 font-medium mb-3">{{
                                $t("total_ward")
                            }}</span>
                            <div class="text-5xl" style="color: #3f51b5; font-size: 20px; font-weight: 800">
                                {{ total_ward }}
                            </div>
                        </div>
                        <div class="flex align-items-center justify-content-center bg-purple-100 border-round"
                            style="width: 4rem; height: 4rem">
                            <i class="pi pi-list text-red-500 text-5xl"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="grid">
            <div class="col-12 lg:col-3 xl:col-3 zoom" style="width: 20%; height: 100%">
                <div class="card mb-0" id="custom_card_shadow" @click="go('/scheme')">
                    <div class="flex justify-content-between mb-0">
                        <div>
                            <span class="block text-500 font-medium mb-3">{{
                                $t("scheme")
                            }}</span>
                            <div class="text-5xl" style="color: #3f51b5; font-size: 20px; font-weight: 800">
                                {{ total_Schemes }}
                            </div>
                        </div>
                        <div class="flex align-items-center justify-content-center bg-purple-100 border-round"
                            style="width: 4rem; height: 4rem">
                            <i class="pi pi-comment text-purple-500 text-5xl"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 lg:col-3 xl:col-3 zoom" style="width: 20%; height: 100%">
                <div class="card mb-0" id="custom_card_shadow" @click="go('/usermaster')">
                    <div class="flex justify-content-between mb-0">
                        <div>
                            <span class="block text-500 font-medium mb-3">{{
                                $t("tolies")
                            }}</span>
                            <div class="text-5xl" style="color: #3f51b5; font-size: 20px; font-weight: 800">
                                {{ total_Tolies }}
                            </div>
                        </div>
                        <div class="flex align-items-center justify-content-center bg-blue-100 border-round"
                            style="width: 4rem; height: 4rem">
                            <i class="pi pi-shopping-cart text-blue-500 text-5xl"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 lg:col-3 xl:col-3 zoom" style="width: 20%; height: 100%">
                <div class="card mb-0" id="custom_card_shadow" @click="go('/usermaster')">
                    <div class="flex justify-content-between mb-0">
                        <div>
                            <span class="block text-500 font-medium mb-3">{{
                                $t("workers")
                            }}</span>
                            <div class="text-5xl" style="color: #3f51b5; font-size: 20px; font-weight: 800">
                                {{ total_Workers }}
                            </div>
                        </div>
                        <div class="flex align-items-center justify-content-center bg-orange-100 border-round"
                            style="width: 4rem; height: 4rem">
                            <i class="pi pi-map-marker text-orange-500 text-5xl"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 lg:col-3 xl:col-3 zoom" style="width: 20%; height: 100%">
                <div class="card mb-0" id="custom_card_shadow" @click="go('/usermaster')">
                    <div class="flex justify-content-between mb-0">
                        <div>
                            <span class="block text-500 font-medium mb-3">{{
                                $t("employers")
                            }}</span>
                            <div class="text-5xl" style="color: #3f51b5; font-size: 20px; font-weight: 800">
                                {{ total_Employers }}
                            </div>
                        </div>
                        <div class="flex align-items-center justify-content-center bg-cyan-100 border-round"
                            style="width: 4rem; height: 4rem">
                            <i class="pi pi-inbox text-cyan-500 text-5xl"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 lg:col-3 xl:col-3 zoom" style="width: 20%; height: 100%">
                <div class="card mb-0" id="custom_card_shadow" @click="go('/usermaster')">
                    <div class="flex justify-content-between mb-0">
                        <div>
                            <span class="block text-500 font-medium mb-3">{{
                                $t("staff")
                            }}</span>
                            <div class="text-5xl" style="color: #3f51b5; font-size: 20px; font-weight: 800">
                                {{ total_Staff }}
                            </div>
                        </div>
                        <div class="flex align-items-center justify-content-center bg-purple-100 border-round"
                            style="width: 4rem; height: 4rem">
                            <i class="pi pi-comment text-purple-500 text-5xl"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
        <div class="grid">
            <div class="col-12 lg:col-12 xl:col-12">
                <div class="card" id="custom_card_shadow">
                    <div class="p-fluid formgrid grid">
                        <div class="field col-2 md:col-2" style="margin-top: 10px">
                            <h4 style="color: #6c757d; font-size: 16px; font-weight: 700">
                                {{ $t("month_wise_tickets") }}
                            </h4>
                        </div>
                        <div class="field col-2 md:col-2" style="margin-top: 10px">
                            <Calendar v-model="datefilter" view="month" dateFormat="mm/yy" />
                        </div>
                        <div class="field col-2 md:col-2" style="margin-top: 10px">
                            <span class="p-float-label">
                                <Dropdown v-model="Wardfilter" :options="WardselectButtonValues" optionLabel="name"
                                    filter>
                                </Dropdown>
                                <label for="name">{{ $t("select_ward") }}</label>
                            </span>
                        </div>
                        <div class="field col-2 md:col-2" style="margin-top: 10px">
                            <Dropdown v-model="statusfilter" :options="selectButtonValues" optionLabel="name"
                                class="custom-dropdown" :placeholder="$t('select_option')" />
                        </div>
                        <div class="field col-12 md:col-2" style="margin-top: 10px">
                            <Button
                            icon="pi pi-refresh"
                            v-tooltip.bottom="$t('refresh')"
                            @click="reset()"
                            class="p-button-rounded p-button-danger"
                            />
                            </div>
                        <div class="field col-12 md:col-12">
                            <div class="flex-container">
                                <Chart type="bar" :data="barData" :options="barOptions" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="grid">
            <div class="col-12 lg:col-6 xl:col-6">
                <div class="card" id="custom_card_shadow">
                    <div class="col-12">
                        <div class="p-fluid formgrid grid">
                            <div class="field col-4 md:col-4" style="margin-top: 10px">
                                <h4 style="color: #6c757d; font-size: 16px; font-weight: 700">
                                    {{ $t("ticket_by") }}
                                </h4>
                            </div>
                            <div class="field col-8 md:col-8">
                                <span class="p-float-label">
                                    <Dropdown v-model="WardselectButtonValue" :options="WardselectButtonValues"
                                        optionLabel="name" filter>
                                    </Dropdown>
                                    <label for="name">{{ $t("select_ward") }}</label>
                                </span>
                            </div>
                            <div class="field col-12 md:col-12">
                                <div class="flex-container">
                                    <Chart @click="go('/tickets')" type="pie" :data="wardPieData" :options="pieOptions"
                                        ref="wardComponent" class="w-full md:w-25rem" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 lg:col-6 xl:col-6">
                <div class="card" id="custom_card_shadow">
                    <div class="col-12">
                        <div class="p-fluid formgrid grid">
                            <div class="field col-4 md:col-4" style="margin-top: 10px">
                                <h4 style="color: #6c757d; font-size: 16px; font-weight: 700">
                                    {{ $t("ticket_by_dept") }}
                                </h4>
                            </div>
                            <div class="field col-8 md:col-8">
                                <Dropdown v-model="selectButtonValue" :options="selectButtonValues" optionLabel="name"
                                    class="custom-dropdown" :placeholder="$t('select_option')" />
                            </div>
                            <div class="field col-12 md:col-12">
                                <div class="flex-container">
                                    <Chart type="pie" ref="categoryComponent" :data="pieData"
                                        :options="categorypieOptions" class="w-full md:w-25rem" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import apis from "@/apis";
import axios from "axios";
export default {
    name: 'MahatakrarGroceryDashboard',
    data() {
        return {
            Wardfilter: '',
            statusfilter: '',
            datefilter: '',
            barOptions: null,
            barData: {
                labels: [],
                height: "50px",
                datasets: [
                    {
                        label: 'Total Tickets',
                        backgroundColor: '#2f4860',
                        data: []
                    }
                ]
            },
            isLoadingModel: false,
            fullPage: true,
            total_categories: 0,
            total_ward: 0,
            total_agent: 0,
            open_tickets: 0,
            inprogress_tickets: 0,
            closed_tickets: 0,
            total_Tolies: 387,
            total_Schemes: 0,
            total_Staff: 27,
            total_Employers: 2982,
            total_Workers: 12983,
            WardData: [],
            WardselectButtonValues: [],
            WardselectButtonValue: null,
            wardPieData: {},
            pieOptions: {},
            selectButtonValues: [],
            selectButtonValue: null,
            categorypieOptions: {},
            pieData: {},
            CategoriesData: [],
        };
    },
    async mounted() {
        this.datefilter = new Date();
        await this.DashboardData();
        await this.get_scheme_count();
        await this.WardDashboard();
        await this.CategoriesDashboard();
        await this.dashboardTicketData();
        this.barOptions = {
            plugins: {
                legend: {
                    labels: {
                        color: '#495057'
                    }
                },
            },
            scales: {
                x: {
                    ticks: {
                        color: '#495057'
                    },
                    grid: {
                        color: '#ebedef',
                    }
                },
                y: {
                    ticks: {
                        color: '#495057'
                    },
                    grid: {
                        color: '#ebedef',
                    }
                },
            }
        };
    },
    watch: {
        currentLocale() {
            this.DashboardData();
            this.get_scheme_count();
            this.WardDashboard();
            this.CategoriesDashboard();
        },
        WardselectButtonValue: function (newVal, Oldval) {
            if (newVal == null) {
                newVal = Oldval;
                this.WardselectButtonValue = { name: newVal.name, code: newVal.code };
            }
            if (this.WardselectButtonValue != null && newVal.name && newVal.code) {
                for (let index = 0; index < this.WardData.length; index++) {
                    if (newVal.name == this.WardData[index].name) {
                        this.WardPieData(this.WardData[index]);
                    }
                }
            }
        },
        selectButtonValue: function (newVal, Oldval) {
            if (newVal == null) {
                newVal = Oldval;
                this.selectButtonValue = { name: newVal.name, code: newVal.code };
            }
            if (this.selectButtonValue != null && newVal.name && newVal.code) {
                for (let index = 0; index < this.CategoriesData.length; index++) {
                    if (newVal.name == this.CategoriesData[index].name) {
                        this.PieData(this.CategoriesData[index]);
                    }
                }
            }
        },
        datefilter: function (newVal, Oldval) {
            this.dashboardTicketData();
        },
        Wardfilter: function (newVal, Oldval) {
            this.dashboardTicketData();
        }
        , statusfilter: function (newVal, Oldval) {
            this.dashboardTicketData();
        }
    },
    computed: {
        currentLocale() {
            return this.$i18n.locale;
        },
    },
    methods: {
        reset(){
            this.Wardfilter='';
            this.datefilter=new Date();
            this.statusfilter='';
            // this.dashboardTicketData();
        },
        D_M_Y_formatDate(date_parm) {
            if (date_parm) {
                let date = new Date(date_parm);
                let dd = date.getDate();
                let mm = date.getMonth() + 1;
                let yyyy = date.getFullYear();
                let new_date = dd + "/" + mm + "/" + yyyy;
                // alert(dd)
                if (dd.toString() != "NaN") {
                    //console.log(new_date);
                    return new_date;
                } else {
                    return date_parm;
                }
            }
        },
        getMonthAndYear(dateString = new Date()) {
            const date = new Date(dateString);
            const month = date.getMonth() + 1; // Month number (1-12)
            const year = date.getFullYear();   // Year number
            return { month, year };
        },
        async dashboardTicketData() {
            var result = this.getMonthAndYear(this.datefilter);
            var data = {
                client_id: localStorage.getItem("client_id"),
                "month": result.month,
                "year": result.year,
                "ward_no": this.Wardfilter?.code,
                "status": this.statusfilter?.code
            };
            var promise = apis.dashboardTicketDetails(data);
            promise
                .then(response => {
                    var temp = response.data.data;
                    var label = [];
                    var data = [];
                    for (let index = 0; index < temp.length; index++) {
                        label.push(this.D_M_Y_formatDate(temp[index]['date']));
                        data.push(temp[index]['ticket_count']);
                    }
                    this.barData.labels = label;
                    this.barData.datasets[0].data = data;
                });
        },
        async CategoriesDashboard() {
            var data = {
                client_id: localStorage.getItem("client_id"),
                user_id: localStorage.getItem("id"),
                lang: this.$i18n.locale,
            };
            this.isLoadingModel = true;
            var promise = apis.ticketByCategoriesDashboard(data);
            promise.then((response) => {
                this.isLoadingModel = false;
                this.CategoriesData = response.data.data;
                this.selectButtonValues = [];
                for (let index = 0; index < this.CategoriesData.length; index++) {
                    this.selectButtonValues.push({
                        name: this.CategoriesData[index].name,
                        code: this.CategoriesData[index]._id,
                    });
                }
                this.selectButtonValue = {
                    name: this.CategoriesData[0].name,
                    code: this.CategoriesData[0]._id,
                };
                this.PieData(this.CategoriesData[0]);
            });
        },
        async PieData(data) {
            console.log(data);
            this.pieData = {
                labels: data.labels,
                datasets: [
                    {
                        data: data.series,
                        backgroundColor: [
                            "#F04136",
                            "#2B3890",
                            "#F7941E",
                            "#39B54A",
                            "#D7F422",
                            "#DE6BBC",
                            "#DEDD59",
                            "#58DEDF",
                        ],
                    },
                ],
            };
        },
        async WardDashboard() {
            var data = {
                client_id: localStorage.getItem("client_id"),
                user_id: localStorage.getItem("id"),
                lang: this.$i18n.locale,
            };
            this.isLoadingModel = true;
            var promise = apis.ticketByWardAdminDashboard(data);
            promise.then((response) => {
                this.isLoadingModel = false;
                this.WardData = response.data.data;
                this.WardselectButtonValues = [];
                for (let index = 0; index < this.WardData.length; index++) {
                    this.WardselectButtonValues.push({
                        name: this.WardData[index].name,
                        code: this.WardData[index].ward_no,
                    });
                }
                this.WardselectButtonValue = {
                    name: this.WardData[0].name,
                    code: this.WardData[0].ward_no,
                };
                this.WardPieData(this.WardData[0]);
            });
        },
        async WardPieData(data) {
            this.wardPieData = {
                labels: data.labels,
                datasets: [
                    {
                        data: data.series,
                        backgroundColor: [
                            "#662D91",
                            "#F04136",
                            "#2B3890",
                            "#F7941E",
                            "#39B54A",
                            "#D7F422",
                            "#DE6BBC",
                            "#DEDD59",
                            "#58DEDF",
                        ],
                    },
                ],
            };
        },
        go(path, ticketType) {
            localStorage.setItem("mis_status_group", ticketType);
            this.$router.push(path);
        },
        async get_scheme_count() {
            var data = {
                client_id: localStorage.getItem("client_id"),
                status: "",
                search: "",
                count: true,
                AsOnDate: "",
            };
            this.isLoadingModel = true;
            var promise = apis.listScheme(data, this.id);
            promise.then((response) => {
                this.isLoadingModel = false;
                this.total_Schemes = response.data.data;
            });
            console.log(data);
        },
        async DashboardData() {
            var data = {
                client_id: localStorage.getItem("client_id"),
                user_id: localStorage.getItem("id"),
            };
            this.isLoadingModel = true;
            var promise = apis.AdminDashboardData(data);
            promise.then((response) => {
                this.isLoadingModel = false;
                var temp = response.data.data;
                this.total_categories = response.data.total_categories
                    ? response.data.total_categories
                    : 0;
                this.total_ward = response.data.total_ward
                    ? response.data.total_ward
                    : 0;
                this.total_agent = response.data.total_agents
                    ? response.data.total_agents
                    : 0;
                for (let index = 0; index < temp.length; index++) {
                    const element = temp[index];
                    //console.log("data",element);
                    //pending
                    if (element._id == 1) {
                        this.open_tickets = element.total;
                    }
                    //inprogress
                    if (element._id == 2) {
                        this.inprogress_tickets = element.total;
                    }
                    //closed
                    if (element._id == 3) {
                        this.closed_tickets = element.total;
                    }
                }
            });
        },
    },
};
</script>